const obj = {
  date: '',
  token: '',
}

export default function AwsTokenModel(params = obj) {
  return {
    ...obj,
    ...params,
  };
};
